import React, { useState, useEffect } from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import './InactivityWarning.css';

const InactivityWarning = ({ isVisible, timeRemaining, onExtendSession, onLogout }) => {
  const [countdown, setCountdown] = useState(Math.ceil(timeRemaining / 1000));

  useEffect(() => {
    if (!isVisible) return;

    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isVisible, onLogout]);

  if (!isVisible) return null;

  return (
    <div className="inactivity-warning-overlay">
      <div className="inactivity-warning-modal">
        <div className="warning-icon">
          <AlertTriangle size={48} color="#ff6b35" />
        </div>
        
        <h2>Session Timeout Warning</h2>
        
        <div className="warning-content">
          <p>You will be logged out due to inactivity in:</p>
          
          <div className="countdown-display">
            <Clock size={24} />
            <span className="countdown-time">{countdown} seconds</span>
          </div>
          
          <p>Click "Stay Logged In" to continue your session.</p>
        </div>
        
        <div className="warning-actions">
          <button 
            className="btn-primary" 
            onClick={onExtendSession}
          >
            Stay Logged In
          </button>
          
          <button 
            className="btn-secondary" 
            onClick={onLogout}
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarning;
